import { SIZE } from "@/configs/sizes";
import { MAP_ZOOM_BREAKPOINTS } from "@/services/map-management/constants";

export const iconMapZoomScaling: Record<keyof typeof MAP_ZOOM_BREAKPOINTS, number> = {
    [MAP_ZOOM_BREAKPOINTS.DEVICE]: 1.25,
    [MAP_ZOOM_BREAKPOINTS.ZONE]: 1,
    [MAP_ZOOM_BREAKPOINTS.FIELD]: 1,
    [MAP_ZOOM_BREAKPOINTS.FARM]: 1,
    [MAP_ZOOM_BREAKPOINTS.REGION]: 1,
    [MAP_ZOOM_BREAKPOINTS.WORLD]: 1,
} as const;

export const iconSizes: Record<SIZE, number> = {
    [SIZE.XS]: 12,
    [SIZE.SM]: 18,
    [SIZE.BASE]: 24,
    [SIZE.LG]: 30,
    [SIZE.XL]: 36,
} as const;

/**
 * Manually measured icon size for group menu items, to account for variable size from progress ring
 *
 * Sort of hacky, consider a rework that doesnt rely on manual measurement
 */
export const menuIconSize = 26;
export const menuIconSizeWithProgressRing = 33;
export const menuBadgeSize = 14;

export const deviceCardIconSize = 38;
export const deviceCardIconBadgeSize = 20;
